/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 4/5/2015
 * Time: 3:07 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    //Template
    var template = require("user-management-templates/agent-groups/agentGroupsFooter.tmpl");
    var CONST = require("const");

    var AgentGroupsFooterView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsFooterView = Marionette.ItemView.extend({
            isPermanent: true,
            className: "agentGroups-footer",
            template: template,
            ui:{
                backToListBtn:".back-to-list-container",
                createNewBtn:".create-new-button",
                createNewContainer:".create-new-container",
                icon:".icon"
            },
            events:{
                "click @ui.backToListBtn":"_backToGroupList",
                "click @ui.createNewBtn":"_createGroup"
            },


            initialize: function (options) {
                LEUserManagement.logger.info("Initializing AgentGroupsFooterView", "AgentGroupsFooterView:initialize");

                this.isAddEnabled = _.has(options, "isAddEnabled")? options.isAddEnabled : false;
                this.isListView = _.has(options, "isListView") ? options.isListView : false;
                this.agentGroupsListChannel = LEUserManagement.media.channel(LEUserManagement.channels.AGENT_GROUP_LIST);
            },

            onRender: function() {
                this.isNavigationEnabled = true;
                this.ui.icon.attr("title", this.tooltip);
                this._setAddEnabled(this.isAddEnabled);
                if (this.isListView) {
                    this.listenTo(this.agentGroupsListChannel,"agentGroups:footer:change:buttonState",this._setAddEnabled);
                }

            },

            onClose: function () {
                LEUserManagement.logger.debug("closing AgentGroupsFooterView", "AgentGroupsFooterView:onClose");
            },

            _setAddEnabled: function (isAddEnabled) {
                this.isAddEnabled = isAddEnabled;
                this.ui.createNewContainer.toggleClass("disabled",!isAddEnabled);
                this._setTooltip(isAddEnabled);
            },

            _setTooltip: function(isAddEnabled) {
                var tooltip = "";
                if (this.isListView) {
                    tooltip = isAddEnabled ? LE.translator.translate("LEUserManagement.agentGroups.footer.create.enabled.list.tooltip") : LE.translator.translate("LEUserManagement.agentGroups.footer.create.disabled.list.tooltip");
                }
                else {
                    tooltip = LE.translator.translate("LEUserManagement.agentGroups.footer.create.edit.tooltip");
                }

                this.ui.createNewBtn.attr("title", tooltip);
                this.ui.createNewBtn.attr("tooltip-text", tooltip);
            },

            _backToGroupList:function (ev) {
                if (this.isNavigationEnabled) {
                    LEUserManagement.router.navigate("agentGroups");

                }
            },

            _createGroup: function() {
                if (this.isNavigationEnabled) {
                    if (this.isAddEnabled) {
                        this.agentGroupsListChannel.trigger("agentGroups:list:createNew");
                    }
                }
            },

            _enableNavigation: function(enabled) {
                this.isNavigationEnabled = enabled;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupsFooterView;

});
